import { ApiUrl } from "../../../assets/data/TkApiUrlProperty";
import http from "../../../services/http";
import {
  IAPI_SUB001_Request,
  IAPI_SUB001_Response,
} from "../../../type/apiType";

/**
 * 補助金交付申請一覧参照API
 * @return httpSubsidyApplyHistoryList
 */
const httpAPI_SUB001 = async (
  param: IAPI_SUB001_Request
): Promise<IAPI_SUB001_Response> => {
  const res = await http.post(ApiUrl.API_SUB001, {
    ...param,
  });

  return res.data;
};

export { httpAPI_SUB001 };
